import { CompanyPayables } from '../modules/finance/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { PayablesView } from './list-views.js';
import type { ViewSetter } from './view-state.js';
import type { FinancialObligationDirection } from '../lib/api.js';

/// Despesas e Receitas: a mesma tela, cada rota com o sentido fixo.
export function CompanyPayablesScreen({
  direction,
  view,
  onView,
}: {
  direction: FinancialObligationDirection;
  view: PayablesView;
  onView: ViewSetter<PayablesView>;
}) {
  const { can, today, timeZone, company } = useCompanyScope();
  const units = company.businessUnits ?? [];
  const consolidated = units.length > 1 && (company.activeBusinessUnitId ?? null) === null;
  /// Na visão consolidada os compromissos só são consultados: gravar acontece numa unidade.
  const may = (permission: string) => !consolidated && can(permission);
  return (
    <GatedCompanyScreen allowed={can('financial_obligations.read')}>
      <CompanyPayables
        direction={direction}
        capabilities={{
          canCreate: may('financial_obligations.create'),
          canUpdate: may('financial_obligations.update'),
          canCancel: may('financial_obligations.cancel'),
          canSettle: may('financial_reconciliation.settle'),
          canClassify: may('accounting.classify'),
          recurrences: {
            canRead: can('financial_recurrences.read'),
            canClassify: may('accounting.classify'),
            canCreate: may('financial_recurrences.create'),
            canUpdate: may('financial_recurrences.update'),
            canArchive: may('financial_recurrences.archive'),
            canGenerate: may('financial_recurrences.generate'),
          },
        }}
        unitNames={
          consolidated ? new Map(units.map((unit) => [unit.id, unit.displayName])) : undefined
        }
        today={today}
        timeZone={timeZone}
        view={view}
        onView={onView}
      />
    </GatedCompanyScreen>
  );
}
